import React from 'react';
import { Link } from 'react-router-dom';

export default function Page404() {
    return (
        <section className="vh-100">
            <div className="container py-5 h-100">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col-12 col-md-8 col-lg-6 col-xl-5">
                        <div className="card shadow-2-strong">
                            <div className="card-body p-5 text-center">
                                <h3 className="mb-4">Erreur 404</h3>
                                <p>La page recherchée est introuvable.</p>
                                <Link to="/" className="btn btn-primary mt-3">
                                    Retour à l'accueil
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}